export default [
  {
    year: 1940,
    population: '350,000',
    overAbstraction: 0,
    waterPerCapita: 0
  },
  {
    year: 1941,
    population: '',
    overAbstraction: 0,
    waterPerCapita: 0
  },
  {
    year: 1942,
    population: '',
    overAbstraction: 0,
    waterPerCapita: 0
  },
  {
    year: 1943,
    population: '',
    overAbstraction: 0,
    waterPerCapita: 0
  },
  {
    year: 1944,
    population: '',
    overAbstraction: 0,
    waterPerCapita: 0
  },
  {
    year: 1945,
    population: '',
    overAbstraction: 0,
    waterPerCapita: 0
  },
  {
    year: 1946,
    population: '400,000',
    overAbstraction: 0,
    waterPerCapita: 0
  },
  {
    year: 1947,
    population: '',
    overAbstraction: 0,
    waterPerCapita: 0
  },
  {
    year: 1948,
    population: '',
    overAbstraction: 0,
    waterPerCapita: 0
  },
  {
    year: 1949,
    population: '421,012',
    overAbstraction: 0,
    waterPerCapita: 0
  },
  {
    year: 1950,
    population: '481,321',
    overAbstraction: 0,
    waterPerCapita: 0
  },
  {
    year: 1951,
    population: '536,446',
    overAbstraction: 0,
    waterPerCapita: 0
  },
  {
    year: 1952,
    population: '576,367',
    overAbstraction: 0,
    waterPerCapita: 0
  },
  {
    year: 1953,
    population: '610,079',
    overAbstraction: 0,
    waterPerCapita: 0
  },
  {
    year: 1954,
    population: '644,196',
    overAbstraction: 0,
    waterPerCapita: 0
  },
  {
    year: 1955,
    population: '682,952',
    overAbstraction: 0,
    waterPerCapita: 0
  },
  {
    year: 1956,
    population: '728,040',
    overAbstraction: 0,
    waterPerCapita: 0
  },
  {
    year: 1957,
    population: '778,771',
    overAbstraction: 0,
    waterPerCapita: 0
  },
  {
    year: 1958,
    population: '832,428',
    overAbstraction: 0,
    waterPerCapita: 0
  },
  {
    year: 1959,
    population: '884,864',
    overAbstraction: 0,
    waterPerCapita: 0
  },
  {
    year: 1960,
    population: '933,102',
    overAbstraction: 15.04,
    waterPerCapita: 812.405289
  },
  {
    year: 1961,
    population: '973,988',
    overAbstraction: 15.97,
    waterPerCapita: 1053.277864
  },
  {
    year: 1962,
    population: '1,010,658',
    overAbstraction: 16.8,
    waterPerCapita: 923.8436741
  },
  {
    year: 1963,
    population: '1,050,213',
    overAbstraction: 17.7,
    waterPerCapita: 792.991517
  },
  {
    year: 1964,
    population: '1,102,399',
    overAbstraction: 18.89,
    waterPerCapita: 1097.497367
  },
  {
    year: 1965,
    population: '1,173,606',
    overAbstraction: 20.51,
    waterPerCapita: 1015.400398
  },
  {
    year: 1966,
    population: '1,267,062',
    overAbstraction: 22.64,
    waterPerCapita: 755.6378457
  },
  {
    year: 1967,
    population: '1,378,998',
    overAbstraction: 25.19,
    waterPerCapita: 1156.36861
  },
  {
    year: 1968,
    population: '1,500,163',
    overAbstraction: 27.95,
    waterPerCapita: 707.1698209
  },
  {
    year: 1969,
    population: '1,617,428',
    overAbstraction: 30.62,
    waterPerCapita: 627.6322655
  },
  {
    year: 1970,
    population: '1,721,323',
    overAbstraction: 32.99,
    waterPerCapita: 569.4166638
  },
  {
    year: 1971,
    population: '1,809,182',
    overAbstraction: 34.99,
    waterPerCapita: 618.42866
  },
  {
    year: 1972,
    population: '1,883,935',
    overAbstraction: 36.69,
    waterPerCapita: 660.1342403
  },
  {
    year: 1973,
    population: '1,948,442',
    overAbstraction: 38.16,
    waterPerCapita: 408.12095
  },
  {
    year: 1974,
    population: '2,007,735',
    overAbstraction: 39.51,
    waterPerCapita: 616.645125
  },
  {
    year: 1975,
    population: '2,065,913',
    overAbstraction: 40.84,
    waterPerCapita: 531.2905239
  },
  {
    year: 1976,
    population: '2,123,180',
    overAbstraction: 42.14,
    waterPerCapita: 464.3318042
  },
  {
    year: 1977,
    population: '2,179,363',
    overAbstraction: 43.42,
    waterPerCapita: 412.8041084
  },
  {
    year: 1978,
    population: '2,237,943',
    overAbstraction: 44.75,
    waterPerCapita: 398.0262232
  },
  {
    year: 1979,
    population: '2,303,122',
    overAbstraction: 46.24,
    waterPerCapita: 380.9524637
  },
  {
    year: 1980,
    population: '2,377,995',
    overAbstraction: 47.94,
    waterPerCapita: 495.3374587
  },
  {
    year: 1981,
    population: '2,464,867',
    overAbstraction: 49.92,
    waterPerCapita: 422.785489
  },
  {
    year: 1982,
    population: '2,653,534',
    overAbstraction: 54.22,
    waterPerCapita: 335.2962502
  },
  {
    year: 1983,
    population: '2,671,413',
    overAbstraction: 54.63,
    waterPerCapita: 406.5152038
  },
  {
    year: 1984,
    population: '2,784,463',
    overAbstraction: 57.2,
    waterPerCapita: 316.2333276
  },
  {
    year: 1985,
    population: '2,900,049',
    overAbstraction: 59.83,
    waterPerCapita: 339.7701211
  },
  {
    year: 1986,
    population: '3,015,299',
    overAbstraction: 51.95,
    waterPerCapita: 300.0000995
  },
  {
    year: 1987,
    population: '3,131,796',
    overAbstraction: 109.64,
    waterPerCapita: 338.6172024
  },
  {
    year: 1988,
    population: '3,256,558',
    overAbstraction: 167.09,
    waterPerCapita: 403.4382314
  },
  {
    year: 1989,
    population: '3,399,330',
    overAbstraction: 184.01,
    waterPerCapita: 342.0173975
  },
  {
    year: 1990,
    population: '3,565,890',
    overAbstraction: 207.11,
    waterPerCapita: 282.0670295
  },
  {
    year: 1991,
    population: '3,760,496',
    overAbstraction: 183.14,
    waterPerCapita: 278.2930762
  },
  {
    year: 1992,
    population: '3,977,672',
    overAbstraction: 199.29,
    waterPerCapita: 314.3748404
  },
  {
    year: 1993,
    population: '4,201,555',
    overAbstraction: 199.41,
    waterPerCapita: 223.2982789
  },
  {
    year: 1994,
    population: '4,410,359',
    overAbstraction: 170.4,
    waterPerCapita: 242.7013311
  },
  {
    year: 1995,
    population: '4,588,843',
    overAbstraction: 152.66,
    waterPerCapita: 242.3181617
  },
  {
    year: 1996,
    population: '4,732,854',
    overAbstraction: 162.47,
    waterPerCapita: 205.4193939
  },
  {
    year: 1997,
    population: '4,848,541',
    overAbstraction: 138.35,
    waterPerCapita: 237.1723782
  },
  {
    year: 1998,
    population: '4,943,975',
    overAbstraction: 145,
    waterPerCapita: 239.8758084
  },
  {
    year: 1999,
    population: '5,031,762',
    overAbstraction: 140.62,
    waterPerCapita: 168.54732
  },
  {
    year: 2000,
    population: '5,122,493',
    overAbstraction: 137,
    waterPerCapita: 179.0553935
  },
  {
    year: 2001,
    population: '5,217,336',
    overAbstraction: 116.91,
    waterPerCapita: 174.2095966
  },
  {
    year: 2002,
    population: '5,317,506',
    overAbstraction: 158.24,
    waterPerCapita: 176.2668439
  },
  {
    year: 2003,
    population: '5,434,030',
    overAbstraction: 157.83,
    waterPerCapita: 281.6804471
  },
  {
    year: 2004,
    population: '5,580,244',
    overAbstraction: 146.65,
    waterPerCapita: 208.6001974
  },
  {
    year: 2005,
    population: '5,765,635',
    overAbstraction: 144.31,
    waterPerCapita: 218.7200543
  },
  {
    year: 2006,
    population: '5,991,540',
    overAbstraction: 117.31,
    waterPerCapita: 168.8831252
  },
  {
    year: 2007,
    population: '6,255,280',
    overAbstraction: 143.98,
    waterPerCapita: 166.9277794
  },
  {
    year: 2008,
    population: '6,556,478',
    overAbstraction: 142.62,
    waterPerCapita: 147.5212759
  },
  {
    year: 2009,
    population: '6,893,260',
    overAbstraction: 134.93,
    waterPerCapita: 138.9037988
  },
  {
    year: 2010,
    population: '7,261,539',
    overAbstraction: 159.17,
    waterPerCapita: 149.7506245
  },
  {
    year: 2011,
    population: '7,663,131',
    overAbstraction: 152.18,
    waterPerCapita: 127.6371238
  },
  {
    year: 2012,
    population: '8,090,872',
    overAbstraction: 158.39,
    waterPerCapita: 134.2624132
  },
  {
    year: 2013,
    population: '8,520,420',
    overAbstraction: 150.29,
    waterPerCapita: 127.0946737
  },
  {
    year: 2014,
    population: '8,920,049',
    overAbstraction: 160.21,
    waterPerCapita: 121.4006784
  },
  {
    year: 2015,
    population: '9,266,575',
    overAbstraction: 176.6,
    waterPerCapita: 127.1235597
  },
  {
    year: 2016,
    population: '9,551,467',
    overAbstraction: 196.48,
    waterPerCapita: 121.8975054
  },
  {
    year: 2017,
    population: '9,779,173',
    overAbstraction: 197.18,
    waterPerCapita: 106.1234933
  },
  {
    year: 2018,
    population: '9,956,011',
    overAbstraction: 204.7,
    waterPerCapita: 97.73994826
  },
  {
    year: 2019,
    population: '10,101,694',
    overAbstraction: '208',
    waterPerCapita: 0
  }
]
